import { Component, HostListener, TemplateRef, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { environment } from '../../shared/config/app-config';
import { FormSessionCanDeactivate, User, UserService } from '../../shared';

@Component({
  selector: 'app-surveymetrics',
  templateUrl: './surveymetrics.component.html',
  styleUrls: ['./surveymetrics.component.css']
})
export class SurveymetricsComponent extends FormSessionCanDeactivate {
  documenturl: string = environment.documenturl;
  activityBoardPDF: { url: any; withCredentials: boolean; };
  public data: Object;
  pdfdocumenturl: string = environment.pdfdocumenturl;
  id: any;
  path: any;
  url: string = "./404.html";
  urlSafe: SafeResourceUrl;
  pdfurl: any;
  public modalRef: BsModalRef;
  @ViewChild('content') content: TemplateRef<any>;
  resultedHref: any;
  CurrentUser: User

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public sanitizer: DomSanitizer,
    private userService: UserService,
    private modalService: BsModalService
  ) {
    super();
  }

  pdfOption: any
  ngOnInit() {
    this.userService.currentUser.subscribe(
      (userData) => {
        this.CurrentUser = userData;
      }
    );

    if (window.localStorage['pdfPath']) {
      this.pdfOption = JSON.parse(window.localStorage['pdfPath'])
      if (this.pdfOption.type == 'html') {
        let pdfPath = {
          'url': encodeURI(this.documenturl + this.pdfOption.path)
        }
        this.userService
          .getpdf(pdfPath)
          .subscribe(
            data => {
              this.urlSafe = data
              this.pdfurl = data
            })
      }
      else
        this.activityBoardPDF = {
          url: this.documenturl + this.pdfOption.path,
          withCredentials: true
        }
    }
    this.route.params.subscribe(params => this.id = params);
    ////console.log(this.id)
    this.userService
      .getactivity(this.id.patid)
      .subscribe(
        data => {
          for (var i = 0; i < data.length; i++) {
            for (var j = 0; j < data[i].data.length; j++) {
              if (data[i].data[j].materialHspPatientMappingId == this.id.mapid) {
                this.path = data[i].data[j].filePath
              }
            }
          }
        }
      );
  }

  completesurvey() {
    let type = "Form"
    this.userService.updatesurvey(this.id.id, type)
      .subscribe(
        data => {
          //////console.log(data);
          if (data.updateStatus == "true") {
            this.userService.logAudit("updatereviewstatus", 0).subscribe(data => { })
            this.router.navigateByUrl('/patient/dashboard');
          }
          else {
          }
        });
  }

  onPrint() {
    let printContents, popupWin;
    if (this.pdfOption.type == 'html') {
      printContents = this.pdfurl.replace('<body>', '<body onload="window.print();window.close();" >')
      popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
      popupWin.document.open();
      popupWin.document.write(`${printContents}`);
      popupWin.document.close();
    } else {
      printContents = this.activityBoardPDF.url
      window.open(printContents, '_blank', 'top=0,left=0,height=100%,width=auto');
    }
  }

  openpopup(href) {
    this.resultedHref = href;
    this.modalRef = this.modalService.show(this.content, {
      class: 'modal-dialog-centered modal-sm content_popup',
      ignoreBackdropClick: true
    });
  }

  @HostListener('document:click', ['$event'])
  pop_up_over(event) {
    $(document).on('click', 'a', function (e) {
      e.preventDefault();
      self.localStorage.setItem('hyperLink', event.target.href);
      return false;
    });

    if (event.target.href) {
      if (localStorage.getItem('hyperLink') && !event.target.href.includes('javascript:void(0)')) {
        this.openpopup(event.target.href);
      }
    }
  }

  onPressYes() {
    window.open(this.resultedHref, '_blank').focus();
    this.modalRef.hide();
    let viewedUaId, patSWFId;
    if (window.localStorage['superClientId']) {
      viewedUaId = window.localStorage.getItem('superClientId');
    }
    else if (window.localStorage['ccdetails']) {
      let ccdetails = JSON.parse(atob(window.localStorage['ccdetails']))
      viewedUaId = ccdetails.cnuseraccid
    }
    else {
      viewedUaId = this.CurrentUser.item.userAccountId;
    }
    if (window.localStorage['Puser']) {
      patSWFId = window.localStorage.getItem('Puser');
    }

    let obj = {
      "handShakeKey": "",
      "hspPatMaterialMapId": this.id.id,
      "latestViewedOn": "",
      "materialTypeId": 1, //For Form
      "patientSwfId": patSWFId,
      "viewedCount": 1,
      "viewedModeId": 1, //For Web
      "viewedUaId": viewedUaId
    };
    this.userService.trackExternalEmbeddedLink(obj)
      .subscribe(data => {

      });
  }

  onPressNo() {
    this.modalRef.hide();
  }
}